import React, { useState, FunctionComponent } from "react";
import { Card } from "react-bootstrap";
import { useMatch } from "react-router-dom";

type AppProps = {
  data: {
    widget: string;
    src: string;
    style: {
      width: string;
      height?: string;
    };
  };
  settings: {
    cctv_stream_1: string;
    cctv_stream_2: string;
  };
};

const WidgetCardSmall: FunctionComponent<AppProps> = (props: AppProps) => {
  const [changeCctv, handleChangeCctv] = useState(true);
  const match = useMatch("/");

  const handleChange = () => {
    handleChangeCctv(!changeCctv);
  };
  const { data, settings } = props;
  if (changeCctv === true && data.widget === "CCTV") {
    data.src = `${settings.cctv_stream_1}`;
  }
  if (changeCctv === false && data.widget === "CCTV") {
    data.src = `${settings.cctv_stream_2}`;
  }

  return (
    <Card className="pb-2 pt-2 px-2 full-height custom-card cctv-panel-card">
      {data.widget === "CCTV" ? (
        <div className="cctv-header">
          <div className="cctv-header__row">
            <span className="cctv-header__label">CCTV 1</span>
            <label className="cctv-toggle">
              <input
                type="checkbox"
                checked={!changeCctv}
                onChange={handleChange}
                aria-label={changeCctv ? "Switch to CCTV 2" : "Switch to CCTV 1"}
              />
              <span className="cctv-toggle__slider" />
            </label>
            <span className="cctv-header__label">CCTV 2</span>
          </div>
          {match && (
            <a href="/cctv" className="custom-btn__circular plus" aria-label="Open CCTV page">
              {" "}
            </a>
          )}
        </div>
      ) : (
        <h6 className="custom-card__title" style={{ margin: 0 }}>
          {data.widget}
          {match && (
            <a href="/windy" className="custom-btn__circular plus">
              {" "}
            </a>
          )}
        </h6>
      )}
      <div className="cctv-panel-card__embed" style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        <iframe
          title={data.widget === "CCTV" ? (changeCctv ? "CCTV 1" : "CCTV 2") : "embed"}
          src={data.src}
          frameBorder="0"
          scrolling="NO"
          sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
          style={{ ...data.style, flex: 1, minHeight: 0 }}
        />
      </div>
    </Card>
  );
};

export default WidgetCardSmall;
